/**
 * MENUS — awaiting the real content.
 * ---------------------------------------------------------------------------
 * The Menus page is fully built and will render whatever you put in here. Two
 * ways to fill it, and you can mix both:
 *
 *   A) Structured menu  — fill `sections[].items[]` below. Prices are plain
 *      numbers in UGX; the page formats them. Anything with `items: []` shows
 *      an "in the kitchen" note instead of an empty list, so the page never
 *      looks broken while you're mid-edit.
 *
 *   B) PDF download     — drop the file in `public/menus/` and set `pdf` on the
 *      menu. A download button appears automatically.
 *
 * Optional flags per item: `signature: true` (gold rule + marker),
 * `vegetarian: true`, `spicy: true`, `note: 'served after 6pm'`.
 */

export const MENUS = [
  {
    id: 'food',
    name: 'Food',
    strapline: 'The everyday Ugandan table, reimagined.',
    pdf: '', // e.g. '/menus/the-local-food-menu.pdf'
    sections: [
      { id: 'starters', name: 'To Start', note: '', items: [] },
      { id: 'mains', name: 'Mains', note: '', items: [] },
      { id: 'grill', name: 'From the Grill', note: '', items: [] },
      { id: 'pizza', name: 'Pizza', note: '', items: [] },
      { id: 'sides', name: 'Sides', note: '', items: [] },
      { id: 'desserts', name: 'Sweet', note: '', items: [] },
    ],
  },
  {
    id: 'drinks',
    name: 'Drinks',
    strapline: 'A bar that knows your order.',
    pdf: '',
    sections: [
      { id: 'signatures', name: 'Signature Cocktails', note: '', items: [] },
      { id: 'classics', name: 'Classics', note: '', items: [] },
      { id: 'wine', name: 'Wine', note: '', items: [] },
      { id: 'beer', name: 'Beer & Cider', note: '', items: [] },
      { id: 'softs', name: 'Softs & Lemonades', note: '', items: [] },
      { id: 'coffee', name: 'Coffee & Tea', note: '', items: [] },
    ],
  },
  {
    id: 'golden-hour',
    name: 'Golden Hour',
    strapline: 'Monday to Thursday, 4pm – 7pm.',
    pdf: '',
    sections: [
      { id: 'gh-drinks', name: 'Happy Hour Pours', note: '', items: [] },
      { id: 'gh-bites', name: 'Bar Bites', note: '', items: [] },
    ],
  },
];

/**
 * EXAMPLE — delete or keep as a reference when you paste the real menu in.
 *
 * {
 *   id: 'mains',
 *   name: 'Mains',
 *   note: 'All mains come with a side of your choosing.',
 *   items: [
 *     {
 *       name: 'Smash Beef Burger',
 *       description: 'Double patty, house sauce, pickles, skin-on fries.',
 *       price: 38000,
 *       signature: true,
 *     },
 *     { name: 'Margherita', description: 'San Marzano, fior di latte, basil.', price: 20000, vegetarian: true },
 *   ],
 * }
 */

export const CURRENCY = 'UGX';

export function formatPrice(value) {
  if (value === null || value === undefined || value === '') return '';
  if (typeof value === 'string') return value;
  return `${CURRENCY} ${value.toLocaleString('en-UG')}`;
}

export function menuHasContent(menu) {
  return menu.sections.some((s) => s.items && s.items.length > 0);
}
